<script>
    export default {
        computed: {
            currency: function () {
                return this.itemArray[this.cart.shoppingCartItemList[0]].articlePrice.currency;
            },
            total: function () {
                return this.cart.shoppingCartItemList.reduce((totalAmount, currentItem) => totalAmount + Number(this.itemArray[currentItem].totalCalculated), 0);
            }
        }
    }
</script>